import React from "react";
import {
    Typography,
    Paper,
    Button,
    Divider,
    List,
    Card,
    CardContent,
    Avatar,
    IconButton,
    makeStyles,
} from "@material-ui/core";

import Icon from "../components/svg/NextIcon";

import MainScreen from "./templates/MainScreen";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
    blackLine: {
        backgroundColor: theme.palette.primary.main,
    },
    inviteButton: {
        backgroundColor: theme.palette.primary.main,
        width: "100%",
        "&:hover": {
            background: theme.palette.primary.main,
        },
        marginTop: "10px",
        marginBottom: "10px",
        paddingTop: "20px",
        paddingBottom: "20px",
    },
    userAvatar: {
        marginTop: "auto",
        marginBottom: "auto",
        marginRight: "20px",
    },
    icon: {
        marginTop: "auto",
        marginBottom: "auto",
        marginLeft: "auto",
    },
    flex: {
        display: "flex",
        flexDirection: "row",
    },
}));

export default function TournamentGames(): JSX.Element {
    const { t } = useTranslation();
    const classes = useStyles();
    return (
        <MainScreen lower={false} back={false}>
            <Paper style={{ overflow: "auto" }} elevation={0}>
                <Button color="primary" classes={{ root: classes.inviteButton }}>
                    <Typography variant="h4" color="secondary">
                        {t("tournament-creator.invite")}
                    </Typography>
                </Button>
                <Typography variant="h6">
                    {t("tournament-creator.players", { number: 5 })}
                </Typography>
                <Divider orientation="horizontal" classes={{ root: classes.blackLine }} />
                <List>
                    <Card variant="outlined">
                        <CardContent className={classes.flex}>
                            <Avatar className={classes.userAvatar} />
                            <Typography variant="h4">
                                Bruno Sousa
                            </Typography>
                            <IconButton className={classes.icon}>
                                <Icon />
                            </IconButton>
                        </CardContent>
                    </Card>
                    <Card variant="outlined">
                        <CardContent className={classes.flex}>
                            <Avatar className={classes.userAvatar} />
                            <Typography variant="h4">
                                Carlos Santos
                            </Typography>
                            <IconButton className={classes.icon}>
                                <Icon />
                            </IconButton>
                        </CardContent>
                    </Card>
                    <Card variant="outlined">
                        <CardContent className={classes.flex}>
                            <Avatar className={classes.userAvatar} />
                            <Typography variant="h4">
                                João Alfredo
                            </Typography>
                            <IconButton className={classes.icon}>
                                <Icon />
                            </IconButton>
                        </CardContent>
                    </Card>
                    <Card variant="outlined">
                        <CardContent className={classes.flex}>
                            <Avatar className={classes.userAvatar} />
                            <Typography variant="h4">
                                Sandra Rodrigues
                            </Typography>
                            <IconButton className={classes.icon}>
                                <Icon />
                            </IconButton>
                        </CardContent>
                    </Card>
                    <Card variant="outlined">
                        <CardContent className={classes.flex}>
                            <Avatar className={classes.userAvatar} />
                            <Typography variant="h4">
                                Zé Fintas
                            </Typography>
                            <IconButton className={classes.icon}>
                                <Icon />
                            </IconButton>
                        </CardContent>
                    </Card>
                </List>
            </Paper>
        </MainScreen>
    );
}
